import myAgreement from "./src/components/myAgreement.vue"
// import myForm from "./src/components/myForm.vue"
import Vant from 'vant';
import myForm from "./src/components/myForm"
import mySelect from "./src/components/mySelect"
import myfieldDate from "./src/components/myfieldDate"
import myLoadMore from "./src/components/myLoadMore"
import myUpFile from "./src/components/myUpFile"
import myMoreBtn from "./src/components/myMoreBtn"
import Dot from "./src/components/dot"
import Mint from "mint-ui";
import 'mint-ui/lib/style.css';
import './public/css/flex.css' /*引入公共样式*/
import "./public/css/style.css"
import 'vant/lib/index.css';
export default {
    install:function(Vue){

        Vue.use(Mint)
        Vue.use(Vant)
        Vue.component("my-form",myForm);
        Vue.component("my-select",mySelect);
        Vue.component("my-fieldDate",myfieldDate)
        Vue.component("my-loadMore",myLoadMore)
        Vue.component('my-upFile',myUpFile)
        Vue.component('my-moreBtn',myMoreBtn)
        Vue.component('dot',Dot)
        // Vue.component(myForm.name,myForm);
        
        setTimeout(() => {
            const agreement = Vue.extend(myAgreement);
            let instance =new agreement()
            document.body.appendChild(instance.$mount().$el)    
            Vue.prototype.$agreement={ 
                show(data={}){
                    return instance.show(data)
                },
                download(data){
                    instance.download(data)
                },
                hide(){
                    instance.hide()
                }
            }
        }, 1000);

    }
}


// WEBPACK FOOTER //
// ./index_target.js